export const placess = [
  {
    id: 1,
    title: "Aşgabat şäheri",
    content: [
      { name: "Bagtyýarlyk etraby" },
      { name: "Berkararlyk etraby" },
      { name: "Köpetdag etraby" },
      { name: "Büzmeýin etraby" },
    ]
  },
  {
    id: 2,
    title: "Ahal welaýaty",
    content: [
      { name: "Bäherden etraby" },
      { name: "Gökdepe etraby" },
      { name: "Ak bugdaý etraby" },
      { name: "Kaka etraby" },
      { name: "Tejen etraby" },
      { name: "Babadaýhan etraby" },
      { name: "Sarahs etraby" },
      { name: "Altyn asyr etraby" },
    ]
  },
  {
    id: 3,
    title: "Balkan welaýaty",
    content: [
      { name: "Balkanabat şäheri" },
      { name: "Türkmenbaşy şäheri" },
      { name: "Gyzylarbat etraby" },
      { name: "Türkmenbaşy etraby" },
      { name: "Bereket etraby" },
      { name: "Etrek etraby" },
      { name: "Esenguly etraby" },
      { name: "Magtymguly etraby" },
    ]
  },
  {
    id: 4,
    title: "Daşoguz welaýaty",
    content: [
      { name: "Daşoguz şäheri" },
      { name: "Şabat etraby" },
      { name: "Görogly etraby" },
      { name: "Akdepe etraby" },
      { name: "Boldumsaz etraby" },
      { name: "Köneürgenç etraby" },
      { name: "Saparmyrat Türkmenbaşy etraby" },
      { name: "Ruhubelent etraby" },
      { name: "Garaşsyzlyk etraby" },
      { name: "Gubadag etraby" },
    ]
  },
  {
    id: 5,
    title: "Lebap welaýaty",
    content: [
      { name: "Türkmenabat şäheri" },
      { name: "Çärjew etraby" },
      { name: "Dänew etraby" },
      { name: "Darganata etraby" },
      { name: "Saýat etraby" },
      { name: "Halaç etraby" },
      { name: "Kerki etraby" },
      { name: "Hojambaz etraby" },
      { name: "Köýtendag etraby" },
      { name: "Farap etraby" },
      { name: "Döwletli etraby" },
      { name: "Garabekewül etraby" },
    ]
  },
  {
    id: 6,
    title: "Mary welaýaty",
    content: [
      { name: "Mary şäheri" },
      { name: "Baýramaly şäheri" },
      { name: "Mary etraby" },
      { name: "Baýramaly etraby" },
      { name: "Wekilbazar etraby" },
      { name: "Türkmengala etraby" },
      { name: "Garagum etraby" },
      { name: "Sakarçäge etraby" },
      { name: "Murgap etraby" },
      { name: "Ýolöten etraby" },
      { name: "Tagtabazar etraby" },
      { name: "Oguzhan etraby" },
    ]
  }
]

export const office = [
  { id: 1, name: 'Türkmenistanyň Ýokary kazyýeti' },

  { id: 2, name: 'Arkadag şäher kazyýeti' },
  { id: 3, name: "Kärizek etrap kazyýeti" },
  { id: 4, name: "Gorjaw etrap kazyýeti" },

  { id: 5, name: "Aşgabat şäher kazyýeti" },
  { id: 6, name: "Bagtyýarlyk etrap kazyýeti" },
  { id: 7, name: "Berkararlyk etrap kazyýeti" },
  { id: 8, name: "Köpetdag etrap kazyýeti" },
  { id: 9, name: "Büzmeýin etrap kazyýeti" },

  { id: 10, name: "Ahal welaýat kazyýeti" },
  { id: 11, name: "Bäherden etrap kazyýeti" },
  { id: 12, name: "Gökdepe etrap kazyýeti" },
  { id: 13, name: "Ak bugdaý etrap kazyýeti" },
  { id: 14, name: "Kaka etrap kazyýeti" },
  { id: 15, name: "Tejen etrap kazyýeti" },
  { id: 16, name: "Babadaýhan etrap kazyýeti" },
  { id: 17, name: "Sarahs etrap kazyýeti" },
  { id: 18, name: "Altyn asyr etrap kazyýeti" },

  { id: 19, name: "Balkan welaýat kazyýeti" },
  { id: 20, name: "Balkanabat şäher kazyýeti" },
  { id: 21, name: "Türkmenbaşy şäher kazyýeti" },
  { id: 22, name: "Gyzylarbat etrap kazyýeti" },
  { id: 23, name: "Türkmenbaşy etrap kazyýeti" },
  { id: 24, name: "Bereket etrap kazyýeti" },
  { id: 25, name: "Etrek etrap kazyýeti" },
  { id: 26, name: "Esenguly etrap kazyýeti" },
  { id: 27, name: "Magtymguly etrap kazyýeti" },

  { id: 28, name: "Daşoguz welaýat kazyýeti" },
  { id: 29, name: "Daşoguz şäher kazyýeti" },
  { id: 30, name: "Şabat etrap kazyýeti" },
  { id: 31, name: "Görogly etrap kazyýeti" },
  { id: 32, name: "Akdepe etrap kazyýeti" },
  { id: 33, name: "Boldumsaz etrap kazyýeti" },
  { id: 34, name: "Köneürgenç etrap kazyýeti" },
  { id: 35, name: "Saparmyrat Türkmenbaşy etrap kazyýeti" },
  { id: 36, name: "Ruhubelent etrap kazyýeti" },
  { id: 37, name: "Garaşsyzlyk etrap kazyýeti" },
  { id: 38, name: "Gubadag etrap kazyýeti" },

  { id: 39, name: "Lebap welaýat kazyýeti" },
  { id: 40, name: "Türkmenabat şäher kazyýeti" },
  { id: 41, name: "Çärjew etrap kazyýeti" },
  { id: 42, name: "Dänew etrap kazyýeti" },
  { id: 43, name: "Darganata etrap kazyýeti" },
  { id: 44, name: "Saýat etrap kazyýeti" },
  { id: 45, name: "Halaç etrap kazyýeti" },
  { id: 46, name: "Kerki etrap kazyýeti" },
  { id: 47, name: "Hojambaz etrap kazyýeti" },
  { id: 48, name: "Köýtendag etrap kazyýeti" },
  { id: 49, name: "Farap etrap kazyýeti" },
  { id: 50, name: "Döwletli etrap kazyýeti" },
  { id: 51, name: "Garabekewül etrap kazyýeti" },

  { id: 52, name: "Mary welaýat kazyýeti" },
  { id: 53, name: "Mary şäher kazyýeti" },
  { id: 54, name: "Baýramaly şäher kazyýeti" },
  { id: 55, name: "Mary etrap kazyýeti" },
  { id: 56, name: "Baýramaly etrap kazyýeti" },
  { id: 57, name: "Wekilbazar etrap kazyýeti" },
  { id: 58, name: "Türkmengala etrap kazyýeti" },
  { id: 59, name: "Garagum etrap kazyýeti" },
  { id: 60, name: "Sakarçäge etrap kazyýeti" },
  { id: 61, name: "Murgap etrap kazyýeti" },
  { id: 62, name: "Ýolöten etrap kazyýeti" },
  { id: 63, name: "Tagtabazar etrap kazyýeti" },
  { id: 64, name: "Oguzhan etrap kazyýeti" },
]

export const auctionLocation = [
  { id: 1, title: 'Aşgabat şäheri' },
  { id: 2, title: 'Arkadag şäheri' },
  { id: 3, title: 'Ahal welaýaty' },
  { id: 4, title: 'Balkan welaýaty' },
  { id: 5, title: 'Daşoguz welaýaty' },
  { id: 6, title: 'Lebap welaýaty' },
  { id: 7, title: 'Mary welaýaty' },
]

export const appeal = [
  { id: 1, name: 'Arza nägilelik (ýakyn wagtda)' },
  { id: 2, name: 'Hak isleýiş arza (ýakyn wagtda)' }
]

export const act = [
  { id: 1, name: 'Höküm' },
  { id: 2, name: 'Çözgüt' },
  { id: 3, name: 'Kesgitnama' }
]


export const lawHelp = [
  {
    id: 1,
    title: "Türkmenistanyň Ýokary kazyýeti",
    content: [
      {
        name: "Türkmenistanyň ýokary kazyýetiniň başlygy",
        day: 'Duşenbe',
        time: '10:00-13:00'
      },
      {
        name: "Türkmenistanyň ýokary kazyýetiniň ýolbaşçylary",
        day: 'Sişenbe, Çarşenbe, Penşenbe',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Aşgabat şäheri 2022-nji köçesiniň 86-njy jaýy',
        time: '10:00 - 13:00',
        phone: '800 12 38-09-32'
      }
    ]
  },
  {
    id: 2,
    title: "Arbitraž kazyýeti",
    content: [
      {
        name: "Arbitraž kazyýetiniň başlygy",
        day: 'Penşenbe',
        time: '15:00-18:00'
      },
    ],
    address: [
      {
        address: 'Aşgabat şäheri 2022-nji köçesiniň 86-njy jaýy',
        time: '15:00 - 18:00',
        phone: '800 12 38-08-91'
      }
    ]
  },
  {
    id: 3,
    title: "Aşgabat şäher kazyýeti",
    content: [
      {
        name: "Aşgabat şäher kazyýetiniň ýolbaşçylary",
        day: 'Çarşenbe, Anna',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Aşgabat şäheri 2022-nji köçesiniň 86-njy jaýy',
        time: '10:00 - 13:00',
        phone: '800 12 38-09-30; 38-09-31'
      }
    ]
  },
  {
    id: 4,
    title: "Arkadag şäher kazyýeti",
    content: [
      {
        name: "Arkadag şäher kazyýetiniň ýolbaşçylary",
        day: 'Sişenbe, Penşenbe',
        time: '10:00-13:00'
      },
    ],
    address: [
      {
        address: 'Arkadag şäheri, Maýa Kulyýewa 5',
        time: '10:00 - 13:00',
        phone: '800 12 57-09-07'
      }
    ]
  },
  {
    id: 5,
    title: "Ahal welaýat kazyýeti",
    content: [
      {
        name: "Ahal welaýat kazyýetiniň ýolbaşçylary",
        day: 'Duşenbe, Çarşenbe, Anna',
        time: '10:00-12:00'
      },
    ],
    address: [
      {
        address: 'Ahal welaýat, Ak bugdaý etrap,Änew şäheri, Ahal köçesi, jaý №1',
        time: '10:00 - 12:00',
        phone: '800 137 33-2-43'
      }
    ]
  },
  {
    id: 6,
    title: "Balkan welaýat kazyýeti",
    content: [
      {
        name: "Balkan welaýat kazyýetiniň ýolbaşçylary",
        day: 'Çarşenbe, Penşenbe',
        time: '10:00-12:00'
      },
    ],
    address: [
      {
        address: 'Balkan welaýatynyň Balkanabat şäheriniň, Gurtgeldi Annaýew köçesi 160 ýaşaýyş jaý toplumy',
        time: '10:00 - 12:00',
        phone: '800 222 6-05-16'
      }
    ]
  },
  {
    id: 7,
    title: "Mary welaýat kazyýeti",
    content: [
      {
        name: "Mary welaýat kazyýetiniň ýolbaşçylary",
        day: 'Duşenbe, Penşenbe',
        time: '09:00-12:00'
      },
    ],
    address: [
      {
        address: 'Mary welaýaty, Mary şäheri, S.Nyýazow köçesiniň 1”a” jaýy',
        time: '09:00 - 12:00',
        phone: '800 522 6-05-56'
      }
    ]
  },
  {
    id: 8,
    title: "Lebap welaýat kazyýeti",
    content: [
      {
        name: "Lebap welaýat kazyýetiniň ýolbaşçylary",
        day: 'Sişenbe, Penşenbe',
        time: '10:00-12:00'
      },
    ],
    address: [
      {
        address: 'Türkmenabat şäheri, Magtymguly köç., 82 "a"',
        time: '10:00 - 12:00',
        phone: '800 422 3-70-21'
      }
    ]
  },
  {
    id: 9,
    title: "Daşoguz welaýat kazyýeti",
    content: [
      {
        name: "Daşoguz welaýat kazyýetiniň ýolbaşçylary",
        day: 'Duşenbe: 10:00-17:00',
        time: 'Penşenbe: 10:00-16:00'
      },
    ],
    address: [
      {
        address: 'Daşoguz şäheri, Garaşsyzlygyň 10 ýyllygy köçesi, 3/1-nji jaýy',
        time: '10:00-17:00;  10:00-16:00',
        phone: '800 322 93-1-12'
      }
    ]
  },
]

